// extracted by mini-css-extract-plugin
export default {"bEntityTag":"BPatentTypeItem-module_bEntityTag_cbba3b25"};